import { MAX_CAMPAIGN_PERIOD_DAYS as e } from "./constants.js";
const r = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"], o = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], s = [
  { label: "2 weeks", days: 14 },
  { label: "1 month", days: 30 },
  { label: "3 months", days: 90 },
  { label: "6 months", days: e }
];
export {
  r as DAYS_OF_WEEK,
  s as DEFAULT_QUICK_PERIODS,
  o as MONTHS
};
